import { Product } from '@shared/components/ui/Product';
import { RenderItemProps } from '@shared/components/ui/VirtualList';
import { faLock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { AffiliatesModel } from '../../models/Affiliates';

// 🎯 Props para Card incluyendo las acciones
export interface CardProps extends RenderItemProps<AffiliatesModel> {
  className?: string;
  showActions?: boolean;
  showIndex?: boolean;
}

// 🎯 Componente de card individual para Location - SRP
export const Card = ({ item: affiliates, className = '', showActions = true }: CardProps) => {
  const { t } = useTranslation('affiliatesModule');

  return (
    <div className={`py-4 border-b border-card-border hover:bg-muted/30 transition-colors ${className}`}>
      <div className="space-y-4">
        {affiliates.product.name} <br />
        {affiliates.qty} <br />
        {affiliates.available_stock_after_event} <br />
        {affiliates.description} <br />
        {affiliates.user.email} <br />
        {affiliates.created_at} <br />
      </div>
    </div>
  );
};
